import { useDraft, useStore } from "../hooks.ts";
import { Choice, Field } from "../ui/elemente.tsx";
import type { SurveyFields } from "../zustand.ts";

/** Lokales Datum (nicht UTC: kurz nach Mitternacht wäre "heute" sonst noch gestern). */
const today = () => {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
};

export function terminFehler(s: Pick<SurveyFields, "dateFixed" | "dateFrom" | "dateTo">): string | null {
  return s.dateFixed === null
    ? "Bitte wählen Sie aus."
    : !s.dateFrom
      ? "Bitte ein Datum angeben."
      : !s.dateFixed && !s.dateTo
        ? "Bitte angeben, bis wann der Umzug spätestens sein soll."
        : !s.dateFixed && s.dateTo! < s.dateFrom
          ? "Das Ende liegt vor dem Anfang."
          : null;
}

/** Felder für den Wunschtermin (Seite "Ihre Angaben", zusammen mit dem Kontakt). */
export function TerminFelder(props: { tried: boolean }) {
  const d = useDraft();
  const store = useStore();
  const s = d.survey;
  const error = terminFehler(s);

  return (
    <>
      <Choice
        label="Wann möchten Sie umziehen?"
        value={s.dateFixed}
        options={[
          { value: true, label: "Fester Tag" },
          { value: false, label: "Ich bin flexibel" },
        ]}
        onChange={(v) => store.updateSurvey({ dateFixed: v, ...(v ? { dateTo: null } : {}) })}
        error={props.tried && s.dateFixed === null ? error : null}
      />
      {s.dateFixed !== null && (
        <>
          <Field
            label={s.dateFixed ? "Umzugstag" : "Frühestens am"}
            type="date"
            min={today()}
            value={s.dateFrom}
            onChange={(v) => store.updateSurvey({ dateFrom: v || null })}
          />
          {!s.dateFixed && (
            <Field
              label="Spätestens am"
              type="date"
              min={s.dateFrom ?? today()}
              value={s.dateTo}
              onChange={(v) => store.updateSurvey({ dateTo: v || null })}
            />
          )}
          {props.tried && error && <p className="error">{error}</p>}
        </>
      )}
    </>
  );
}
